export const apiEndPoint = {
	login: "login",
	change_password: "change_password",
	profile: "profile",
	client_details: "/details",
	job_work: {
		job_work: "/job_work",
		invoices: "/invoices",
		invoice_by_id: "/invoices",
		create_invoice: "/invoices",
		job_by_client_not_invoiced: "/invoices/dropdowns/not-invoice-jobs",
		job_by_client: "/invoices/dropdowns/jobs",
		invoice_pdf: "/invoices/invoice_pdf",
		job_work_deleted: "/job_work_deleted",
		recover: "/job_work_deleted",
		return: "/job_return",
		assign: "/job_assign_details",
		complete: "/job_complete",
		delivery: "/job_delivery_details",
		delivery_history: "/job_delivery_details/history",
		physical_delivery: "/physical_delivery",
		physical_delivery_history: "/physical_delivery/history",
		summary: "/job_work/summary",
		payment: "/payment_details",
		tds_payment: "/payment_details/tds",
		statement: "/payment_details/statement",
		invoice: "/job_work/invoice",
		monthly_report: "/job_work/monthly_report",
		recalculate_gst: "job_work/recalc_gst",
	},
	expense: "/expenses",
	master: {
		permission: "/permission",
		user: {
			base: "/user",
			toggle: "/user/toggle/:id",
			reset: "/user/reset_password/:id",
		},
		user_permission: {
			base: "/user_permission/:mobile",
			not_assigned: "/user_permission/not_assigned/:id",
			create: "/user_permission",
			toggle: "/user_permission/toggle/:id",
			delete: "/user_permission/:id",
		},
		staff: "/staff",
		bank_upi_details: "/bank_upi_details",
		client: "/client",
		client_toggle: "/client/toggle",
		product: "/product",
		work_type: "/work_type",
	},
	list: {
		user: "/list/user",
		staff: "/list/staff",
		bank_upi_details: "/list/bank_upi_details",
		client: "/list/client",
		product: "/list/product",
		work_type: "/list/work_type",
		transporter: "/list/transporter",
		job_work: "/list/job_work",
		gst_state_code: "/list/gst_state_code",
	},
	dashboard: {
		states: "/dashboard/states",
		top_selling: "/dashboard/top_selling",
		processing: "/dashboard/processing",
		pending: "/dashboard/pending",
	},
	app_settings: {
		company: "/app_settings/company",
		notification: "/app_settings/notification",
		invoice: "/app_settings/invoice",
		job: "/app_settings/job",
	},
};

export const pageRoutes = {
	login: "/session/signin",
	error: "/session/404",
	home: "/dashboard/default",
	client_home: "/",
	profile: "/profile",
	settings: "/settings",
	job_work: {
		list: "/job_work",
		invoices: "/job_invoices",
		deleted: "/deleted",
		details: "/job_work_details/:id?",
		delivery: "/job_delivery/:id?",
		physical_delivery: "/job_physical_delivery/:id?",
		summary: "/summary/:id?",
		payment: "/payments",
		tds_payment: "/tds_payments",
		statement: "/statement",
		invoice: "/invoice/:id?",
	},
	expense: "/expenses",
	master: {
		permission: "/master/permission",
		user: "/master/user",
		user_permission: "/master/user_permission/:id",
		staff: "/master/staff",
		bank_upi_details: "/master/bank_upi_details",
		client: "/master/client",
		product: "/master/product",
		work_type: "/master/work_type",
	},
};
